import { createContext, useContext } from 'react';
import { tBirdieContext } from './Birdie.types';

const initialState: tBirdieContext = {
  isInitialized: false,
};

export const BirdieContext = createContext<tBirdieContext>(initialState);

/**
 * Hook to access Birdie context
 * @returns tBirdieContext
 */
export function useBirdieContext(): tBirdieContext {
  return useContext(BirdieContext);
}
